"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultConfig = {
    loader: {
        load: ["a11y/semantic-enrich", "a11y/explorer", "a11y/assistive-mml"]
    },
    options: {
        enableEnrichment: true,
        enableExplorer: true,
        enableAssistiveMml: true,
        enableMenu: false,
        ignoreHtmlClass: "lrn_noMath",
        sre: {
            speech: "none", // or 'shallow', or 'deep'
            domain: "mathspeak", // speech rules domain
            style: "default", // speech rules style
            locale: "en" // the language to use (en, fr, es, de, it)
        }
    },
    tex: {
        inlineMath: [
            ["\\(", "\\)"],
            ["$$", "$$"]
        ],
        displayMath: [["\\[", "\\]"]],
        macros: {
            abs: ["{|#1|}", 1],
            degree: ["°"],
            longdiv: ["{\\enclose{longdiv}{#1}}", 1],
            atomic: ["{_{#1}^{#2}}", 2],
            polyatomic: ["{_{#2}{}^{#1}}", 2],
            circledot: ["{\\odot}"],
            parallelogram: ["\\unicode{x25B1}"],
            ngtr: ["\\unicode{x226F}"],
            nless: ["\\unicode{x226E}"],
            MathQuillVarField: ["#1", 1],
            // We create a macro alias for the overarc command to be interpreted as overparen
            // Since overparen is supported by default in mathjax and overarc isn't
            overarc: ["{\\overparen{#1}}", 1]
        }
    },
    chtml: {
        minScale: 1,
        matchFontHeight: false
    }
};
// Send a config value for overrides, else send {} for default
var loadMathJax = function (config, callback) {
    var _a;
    var checkArrayValues = function (arr, target) { return target.every(function (v) { return arr.includes(v); }); };
    var customConfig = config !== null && config !== void 0 ? config : {};
    if ((_a = customConfig === null || customConfig === void 0 ? void 0 : customConfig.loader) === null || _a === void 0 ? void 0 : _a.load) {
        // The following config is required for Speechstream to work correctly
        if (!checkArrayValues(customConfig.loader.load, ["a11y/semantic-enrich", "a11y/explorer", "a11y/assistive-mml"])) {
            // eslint-disable-next-line no-console
            console.warn("MathJax: Custom loader.load does not include a11y/semantic-enrich, a11y/explorer, a11y/assistive-mml. Speechstream is unlikely to work correctly.");
        }
    }
    if (typeof (window === null || window === void 0 ? void 0 : window.MathJax) !== "undefined") {
        // MathJax is already loaded
        if (callback)
            callback();
        return;
    }
    var mathjaxScript = "MATHJAX_PROVIDER_SCRIPT";
    var existingScript = document.getElementById(mathjaxScript);
    if (!existingScript) {
        // Set the MathJax config in the Dom before loading the script as it uses this config
        window.MathJax = __assign(__assign({}, defaultConfig), customConfig);
        var script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml-full.js";
        script.id = mathjaxScript;
        document.body.appendChild(script);
        script.onload = function (item) {
            if (callback)
                callback(item);
        };
    }
    if (existingScript && callback)
        callback();
};
var useMathJax = function (config, callback) {
    if (config === void 0) { config = {}; }
    if (callback === void 0) { callback = function () { }; }
    var customConfig = config !== null && config !== void 0 ? config : {};
    var _a = (0, react_1.useState)(), MathJax = _a[0], setMathJax = _a[1];
    var format = function () {
        var _a;
        if (typeof ((_a = window === null || window === void 0 ? void 0 : window.MathJax) === null || _a === void 0 ? void 0 : _a.typeset) !== "undefined") {
            window.MathJax.typeset();
        }
    };
    (0, react_1.useEffect)(function () {
        loadMathJax(customConfig, function () {
            if (!MathJax) {
                setMathJax(window.MathJax);
            }
            if (typeof (window === null || window === void 0 ? void 0 : window.MathJax) !== "undefined") {
                format();
            }
            if (typeof callback === "function") {
                callback();
            }
        });
        if (typeof (window === null || window === void 0 ? void 0 : window.MathJax) !== "undefined") {
            setMathJax(window.MathJax);
            format();
        }
    }, []);
    return { MathJax: MathJax, format: format };
};
exports.default = useMathJax;
